<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-col w-full mb-2">
          <vs-button
            @click="isShowCreatePopup()"
            class="bg_l_green"
            icon-pack="feather"
            icon="icon-plus"
            v-has-permission="permission307"
          >
            {{ $t("CreateNewTransportTool") }}
          </vs-button>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :columns="[
                { title: $t('model') },
                { title: $t('plate') },
                { title: $t('nickName') },
                { title: $t('typeOfTransport') },
                { title: $t('CreateOn') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 20%">{{ row.model ? row.model : "---" }}</td>
                <td style="width: 20%">{{ row.plate ? row.plate : "---" }}</td>
                <td style="width: 20%">
                  {{ row.nickName ? row.nickName : "---" }}
                </td>
                <td style="width: 20%">
                  <span v-if="row.transportDiscriminator == 'Truck'">
                    {{ $t("Truck") }}</span
                  >
                  <span v-else-if="row.transportDiscriminator == 'PickUp'">
                    {{ $t("PickUp") }}</span
                  >
                  <span v-else> {{ $t("Motorcycle") }}</span>
                </td>
                <td style="width: 15%">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
        <create-popup
          :show="onShowCreatePopup"
          @finish="onfinish"
          @close="closeCreatePopup"
        ></create-popup>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import CreatePopup from "./CreatePopup.vue";

export default {
  name: "shipping-TransportTools",
  components: {
    DataGrid,
    CreatePopup,
  },
  data() {
    return {
      permission307: "CreateBike|CreateTruck",
      onShowCreatePopup: false,
      gridDataSource: {
        type: "app",
        service: "Shipping/api/TransportsQuery",
      },
    };
  },
  methods: {
    isShowCreatePopup() {
      this.onShowCreatePopup = true;
    },
    closeCreatePopup() {
      this.onShowCreatePopup = false;
    },
    onfinish() {
      this.closeCreatePopup();
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 0);
    },
  },
};
</script>
